export const reasons = [
    {
        displayName: 'Incomplete Profile',
        reason: 'Your profile information is incomplete, update your profile and try again.',
    },
    {
        displayName: 'Unverified email',
        reason: 'Your email address is unverified, please complete the verification process.',
    },
    {
        displayName: 'Max submissions reached',
        reason: 'The maximum allowed codes for this campaign has been reached.',
    },
    {
        displayName: 'Not qualified',
        reason: 'You do not meet the requirements for this campaign.',
    },
    {
        displayName: 'Others',
        reason: 'We reached this decision based on internal factors.',
    },
];
